/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as r from "react";
import s from "prop-types";
import { classNames as a } from "@progress/kendo-react-common";
const t = (e) => /* @__PURE__ */ r.createElement("div", { style: e.style, className: a("k-card-body", e.className) }, e.children);
t.propTypes = {
  className: s.string
};
export {
  t as CardBody
};
